<template>
  <vs-card class="p-2">
    <vs-row vs-xs="12">
      <vs-col vs-sm="12" vs-lg="4">
        <div class="flex">
          <img
            class="rounded-lg h-32 w-32 md:w-64 lg:w-32 object-cover"
            :src="getUrlOfFile(models.thumbnail, true)"
            alt="campaign-photo"
          />
          <div class="flex flex-col justify-around pl-4">
            <div>
              <div class="flex items-center w-full justify-between">
                <h4>{{ models.title }}</h4>
              </div>
              <h6>{{ models.campaign_type }} - {{ models.reward_type }}</h6>
            </div>
            <div class="my-2">
              <div
                v-for="(type, index) in models.platform_type"
                :key="index"
                class="flex flex-row items-center"
              >
                <a class="font-bold mr-2 text-base" v-text="type.type"></a>
                <span v-text="type.subPlatformText.join(', ')"></span>
              </div>
            </div>
            <h6
              :class="[
                models.status_by_duration === 'Active'
                  ? 'text-success'
                  : 'text-danger',
              ]"
            >
              {{ models.status_by_duration }}
            </h6>
          </div>
        </div>
      </vs-col>
      <vs-col vs-sm="12" vs-lg="8" class="lg:pl-4 mt-10 lg:mt-0">
        <vs-row class="min-h-full">
          <vs-col
            vs-lg="3"
            vs-xs="6"
            class="border-grey lg:border-solid border-0 border-l flex justify-around min-h-full flex-col px-6"
          >
            <div>
              <p class="text-sm">Category</p>
              <h6 class="font-bold">{{ models.category }}</h6>
            </div>
            <div>
              <p class="text-sm">Type</p>
              <h6 class="font-bold">
                {{
                  models.type
                    ? models.type === 1
                      ? "Monthly Campaign"
                      : "Special Campaign"
                    : ""
                }}
              </h6>
            </div>
            <div>
              <p class="text-sm">Brand</p>
              <h6 class="font-bold">{{ models.brand }}</h6>
            </div>
          </vs-col>
          <vs-col
            vs-lg="5"
            vs-xs="6"
            class="border-grey md:border-solid border-0 border-l flex justify-around min-h-full flex-col px-6"
          >
            <div>
              <p class="text-sm">Registration Campaign</p>
              <h6 class="font-bold">{{ models.registration_campaign }}</h6>
            </div>
            <div>
              <p class="text-sm">Duration Campaign</p>
              <h6 class="font-bold">{{ models.duration_campaign }}</h6>
            </div>
          </vs-col>
          <vs-col
            vs-lg="4"
            vs-xs="6"
            class="border-grey md:border-solid border-0 border-l flex justify-around min-h-full flex-col px-6"
          >
            <div>
              <p class="text-sm">Target User</p>
              <h6 class="font-bold">{{ models.target || "-" }}</h6>
            </div>
            <div>
              <p class="text-sm">Approvement</p>
              <h6 class="font-bold">{{ models.approvement || "-" }}</h6>
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>

    <vs-row vs-xs="12" class="my-5">
      <vs-col
        v-for="(stat, index) in masters.stats.filter((stat) => stat.value)"
        :key="index"
        vs-lg="2"
        vs-sm="4"
        vs-xs="6"
        class="py-3 px-2"
      >
        <vs-card class="shadow-md rounded-lg">
          <div
            class="h-32 flex flex-col justify-center items-center text-center"
          >
            <p
              class="text-base text-black text-opacity-75 capitalize"
              v-text="stat.text"
            />
            <p
              style="overflow-wrap: anywhere"
              class="text-lg font-bold text-opacity-75"
              v-text="stat.value"
            />
          </div>
        </vs-card>
      </vs-col>
    </vs-row>

    <vs-row vs-type="flex" vs-w="12" vs-justify="space-between">
      <vs-col vs-lg="5" vs-sm="12" vs-xs="12">
        <vs-button
          v-for="type in masters.types"
          :key="type.value"
          class="rounded-sm lg:w-auto w-full"
          :class="{
            'text-primary': type.value !== config.additional_params.type,
          }"
          :color="
            type.value === config.additional_params.type ? 'primary' : '#fff'
          "
          type="filled"
          @click="config.additional_params.type = type.value"
          >{{ type.text }}
        </vs-button>
      </vs-col>
      <vs-col
        class="my-5 lg:my-0"
        v-if="
          config.additional_params.type === 'report' && masters.platforms.length
        "
        vs-lg="7"
        vs-sm="12"
        vs-xs="12"
        vs-type="flex"
        vs-justify="flex-end"
      >
        <vs-row>
          <vs-col vs-w="12" class="md:flex grid grid-cols-3">
            <vs-button
              v-for="type in masters.platforms"
              :key="type.value"
              class="rounded-sm px-5"
              :class="{ 'text-primary': type.value !== platform }"
              :color="type.value === platform ? 'primary' : '#fff'"
              type="filled"
              @click="config.additional_params.platform = type.value"
              >{{ type.text }}
            </vs-button>
          </vs-col>
          <vs-divider />
          <vs-col vs-w="12" class="md:flex grid grid-cols-4">
            <vs-button
              v-for="type in subPlatformList"
              :key="type.id"
              class="rounded-sm px-5"
              :class="{ 'text-primary': type.id !== subplatform }"
              :color="type.id === subplatform ? 'primary' : '#fff'"
              type="filled"
              @click="
                config.additional_params.subPlatformType = type.id;
                getReports();
              "
              >{{ type.name }}
            </vs-button>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>

    <ResponseAlert ref="response" class="mt-3" />
    <div v-if="config.additional_params.type === 'brand_ambassador'">
      <vs-table
        :sst="true"
        :data="masters.ambassadors"
        stripe
        :multiple="Boolean(masters.ambassadors.length)"
        @sort="handleSort"
        v-model="models.selectedUser"
        style="white-space: nowrap; border: 0.5px solid #acacac"
        class="p-4 rounded-lg mt-2"
      >
        <template slot="header">
          <vs-row class="my-5">
            <h3>Brand Ambassador</h3>
            <vs-row
              class="justify-between items-center my-3"
              vs-type="flex"
              vs-w="12"
            >
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12">
                <div class="flex">
                  <vs-button
                    target
                    @click="exportExcel"
                    class="w-full md:w-2/5 mt-2 px-0 mx-0 md:mx-1"
                    color="primary"
                    type="border"
                    icon="description"
                    >Export</vs-button
                  >
                  <vs-button
                    target
                    @click="vars.popUpImport = true"
                    class="w-full md:w-2/5 mt-2 px-0 mx-0 md:mx-1"
                    color="primary"
                    type="border"
                    icon="folder"
                    >Import Resi</vs-button
                  >
                </div>
              </vs-col>
              <vs-col
                class="mt-4 md:mt-0 flex md:items-center flex-col md:flex-row"
                vs-lg="3"
                vs-sm="5"
                vs-xs="12"
              >
                <span class="mr-2">Filter by status: </span>
                <select class="w-full" v-model="models.status">
                  <option
                    v-for="(status, index) in masters.statuses"
                    :key="index"
                    :value="status.value"
                  >
                    {{ status.text }}
                  </option>
                </select>
              </vs-col>
            </vs-row>
            <vs-divider />

            <vs-row
              class="justify-between items-center whitespace-pre-wrap md:whitespace-no-wrap"
              vs-type="flex"
              vs-w="12"
            >
              <vs-col vs-lg="2" vs-sm="5" vs-xs="12">
                <span class="ml-1 mr-2">Bulk Action Status: </span>
                <select class="w-full" v-model="models.bulking_action">
                  <option :value="null" disabled>Select Actions</option>
                  <option
                    v-for="(action, index) in masters.bulking_actions"
                    :key="index"
                    :value="action.value"
                  >
                    {{ action.text }}
                  </option>
                </select>
                <vs-button
                  target
                  :disabled="!models.bulking_action"
                  @click="bulkChangeStatus"
                  class="mt-2 px-0 mx-0 md:mx-1 w-full md:w-1/3 lg:w-2/3"
                  color="primary"
                  >Apply</vs-button
                >
              </vs-col>
            </vs-row>
          </vs-row>
        </template>
        <template slot="thead">
          <vs-th
            :sort-key="row.value"
            v-for="(row, key) in config.headers"
            :key="key"
            :width="row.width"
            :class="row.class"
          >
            {{ row.title }}
          </vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr
            style="cursor: pointer"
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            not-click-selected
          >
            <vs-td :data="data[indextr].name">
              <div class="flex items-center">
                <button
                  @click="handleSelected(data[indextr])"
                  class="h-full bg-transparent border-none outline-none underline cursor-pointer"
                >
                  {{ data[indextr].name }}
                </button>

                <vs-button
                  v-if="data[indextr].isSuspend"
                  title="Suspend"
                  color="danger"
                  icon="cancel"
                  radius
                  size="small"
                  type="flat"
                ></vs-button>
              </div>
            </vs-td>
            <vs-td :data="tierName(data[indextr])">
              {{ tierName(data[indextr]) || "-" }}
            </vs-td>
            <vs-td :data="data[indextr].maritalStatus">
              {{ maritalStatus(data[indextr].maritalStatus) }}
            </vs-td>
            <vs-td :data="data[indextr].community">
              <button
                v-if="data[indextr].community"
                class="h-full bg-transparent border-none outline-none underline cursor-pointer"
              >
                {{
                  data[indextr].community
                    ? data[indextr].community.join(", ")
                    : "-"
                }}
              </button>
            </vs-td>
            <vs-td :data="data[indextr].email">
              <button
                @click="handleSelected(data[indextr])"
                class="h-full bg-transparent border-none outline-none underline cursor-pointer"
              >
                {{ data[indextr].email }}
              </button>
            </vs-td>
            <vs-td>
              {{
                data[indextr].jobs.publicId ? data[indextr].jobs.publicId : "-"
              }}
            </vs-td>
            <vs-td v-if="platformTypeText.includes('Instagram')">
              {{ followerFormatter(data[indextr].followerIG) }}
            </vs-td>
            <vs-td v-if="platformTypeText.includes('Facebook')">
              {{ followerFormatter(data[indextr].followerFB) }}
            </vs-td>
            <vs-td v-if="platformTypeText.includes('Tiktok')">
              {{ followerFormatter(data[indextr].followerTT) }}
            </vs-td>
            <vs-td v-if="platformTypeText.includes('Youtube')">
              {{ followerFormatter(data[indextr].followerYT) }}
            </vs-td>
            <vs-td v-if="platformTypeText.includes('Twitter')">
              {{ followerFormatter(data[indextr].followerTwitter) }}
            </vs-td>
            <vs-td v-if="platformTypeText.includes('Lemon8')">
              {{ followerFormatter(data[indextr].followerLemon8) }}
            </vs-td>
            <vs-td v-if="platformTypeText.includes('Threads')">
              {{ followerFormatter(data[indextr].followerThreads) }}
            </vs-td>
            <vs-td v-if="platformTypeText.includes('Shopee')">
              {{ followerFormatter(data[indextr].followerShopee) }}
            </vs-td>
            <vs-td v-if="platformTypeText.includes('GDrive')"> </vs-td>
            <vs-td>
              {{
                data[indextr].jobs.shipping
                  ? data[indextr].jobs.shipping.awb
                  : "-"
              }}
            </vs-td>
            <vs-td :data="data[indextr].bod">
              {{ data[indextr].bod }}
            </vs-td>
            <vs-td :data="data[indextr].city">
              {{ data[indextr].city }}
            </vs-td>
            <vs-td :data="data[indextr].province">
              {{ data[indextr].province }}
            </vs-td>
            <vs-td :data="data[indextr].status">
              <span
                :class="[
                  data[indextr].status === 1 ? 'text-warning' : 'text-danger',
                ]"
                class="font-bold"
                v-if="data[indextr].status === 1 || data[indextr].status === 8"
              >
                {{ data[indextr].status_apply }}
              </span>
              <div v-else>
                <span class="block font-bold text-success">{{
                  data[indextr].status_apply
                }}</span>
                <small class="capitalize">{{
                  data[indextr].jobs.status_job
                }}</small>
              </div>
            </vs-td>
            <vs-td>
              <div @click.stop>
                <div
                  v-if="data[indextr].status === 1"
                  class="flex justify-around"
                >
                  <vs-button
                    @click="changeStatusSub(data[indextr].id, true)"
                    title="Approve"
                    color="success"
                    type="flat"
                    icon="done"
                  ></vs-button>
                  <vs-button
                    @click="rejectApplies(data[indextr].id, false)"
                    title="Reject"
                    color="danger"
                    type="flat"
                    icon="close"
                  ></vs-button>
                </div>
                <div
                  v-else-if="data[indextr].status === 8"
                  class="flex justify-around"
                >
                  <vs-button
                    @click="revertDecline(data[indextr])"
                    title="Revert to Submission"
                    color="danger"
                    type="flat"
                    icon="undo"
                  ></vs-button>
                </div>
                <div class="flex flex-row justify-around" v-else>
                  <vs-button
                    v-if="data[indextr].status !== 2"
                    @click="getDetailJob(data[indextr].jobs.id)"
                    class=""
                    title="Detail Content"
                    color="primary"
                    type="flat"
                    icon="book"
                  ></vs-button>
                  <vs-button
                    v-if="
                      data[indextr].status !== 1 && data[indextr].status !== 7
                    "
                    @click="cancelJob(data[indextr].jobs.id)"
                    class=""
                    title="Cancel Job"
                    color="danger"
                    type="flat"
                    icon="cancel"
                  ></vs-button>
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <Pagination :config="config" @gotoPage="gotoPage" />
    </div>
    <vs-row v-else>
      <vs-col vs-w="12" v-if="masters.reports.length">
        <div class="flex gap-2 mb-5">
          <vs-button
            icon="description"
            target
            @click="exportER"
            color="primary"
            type="border"
            >Export</vs-button
          >
          <vs-button
            icon="sync"
            title="Sync ER Instagram dan TikTok"
            @click="syncER"
            color="primary"
            type="border"
            >Sync ER</vs-button
          >
        </div>
        <report-card
          v-for="(report, index) in masters.reports"
          :key="index"
          :report="report"
        />
      </vs-col>
      <vs-col vs-w="12" v-else>
        <h6 class="text-center my-10">No reports found</h6>
      </vs-col>
    </vs-row>

    <vs-row class="mt-20">
      <vs-button
        @click="$router.push({ name: config.uri })"
        color="rgb(172,172,172)"
        type="border"
        >Cancel</vs-button
      >
    </vs-row>

    <vs-popup title="Send Reminder" :active.sync="vars.popUpReminder">
      <div class="px-5 py-3">
        <main class="mb-4">
          <label for="reminderNotes">Notes</label>
          <vs-textarea
            class="mb-0"
            v-model="models.reminderNotes"
            placeholder="Enter reminder notes..."
            name="reminder notes"
          />
        </main>
        <vs-row vs-w="12">
          <div class="w-1/2 pr-2">
            <vs-button
              @click="sendReminderWithNotes"
              class="w-full"
              type="filled"
              color="success"
              >Send</vs-button
            >
          </div>
          <div class="w-1/2 pl-2">
            <vs-button
              @click="closeReminderPopup"
              class="w-full"
              type="filled"
              color="rgb(172,172,172)"
              >Close</vs-button
            >
          </div>
        </vs-row>
      </div>
    </vs-popup>

    <vs-popup button-close-hidden title="" :active.sync="vars.popUpBA">
      <div class="px-5" v-if="detailJob">
        <div v-if="!vars.isRejectReason">
          <main class="py-5">
            <div
              class="content mb-5"
              v-if="models.approvement === 'All With Approvement'"
            >
              <h5 class="mb-2">Link Draft Content</h5>
              <a
                v-if="detailJob.job_drafts"
                class="block"
                :href="detailJob.job_drafts.urlDraft"
                target="_blank"
                >{{ detailJob.job_drafts.urlDraft }}</a
              >
              <p v-else>Data belum tersedia</p>
              <small v-if="detailJob.status === 4"
                >Feedback: {{ detailJob.job_drafts.revisionNote }}</small
              >
            </div>
            <div
              class="content"
              v-if="
                detailJob.status === 5 ||
                detailJob.status === 6 ||
                detailJob.status === 7
              "
            >
              <h5>Link Publish Content</h5>
              <div v-if="detailJob.job_content.length" class="my-3">
                <div
                  class="flex flex-col mt-2"
                  v-for="(data, index) in detailJob.job_content"
                  :key="index"
                >
                  <span class="mr-2 font-medium text-muted flex items-center">
                    <div v-html="data.icon" class="mr-2"></div>
                    {{ data.platformText
                    }}<strong class="ml-1">{{
                      data.subPlatformText && `(${data.subPlatformText})`
                    }}</strong
                    >:
                  </span>
                  <div v-if="data.links && data.links.length">
                    <template v-if="data.links.some((link) => link.urlContent)">
                      <div
                        v-for="(link, lidx) in data.links"
                        :key="lidx"
                        v-if="link.urlContent"
                        class="mb-2 flex items-center justify-between"
                      >
                        <a
                          :href="link.urlContent"
                          target="_blank"
                          class="truncate text-primary underline"
                          >{{ link.urlContent }}</a
                        >
                        <span class="ml-2 min-w-[120px] text-right block">
                          Engagement Rate:
                          <span class="font-bold text-base">
                            {{
                              link.engagementresult === null ||
                              link.engagementresult === undefined ||
                              link.engagementresult === "" ||
                              link.engagementresult === false ||
                              link.engagementresult === "null" ||
                              Array.isArray(link.engagementresult) ||
                              isNaN(Number(link.engagementresult))
                                ? "-"
                                : Number(link.engagementresult).toFixed(2) + "%"
                            }}
                          </span>
                        </span>
                      </div>
                    </template>
                    <template v-else>
                      <span>Data belum tersedia</span>
                    </template>
                  </div>
                  <div v-else>
                    <span>Data belum tersedia</span>
                  </div>
                </div>
              </div>
            </div>
          </main>

          <vs-row vs-w="12">
            <div class="w-1/4 md:w-1/5 pr-1">
              <vs-button
                @click="vars.popUpBA = false"
                class="w-full"
                type="filled"
                color="rgb(172,172,172)"
                >Close</vs-button
              >
            </div>
            <div
              v-if="
                (models.approvmentType == 3 && detailJob.status == 5) ||
                detailJob.status == 3 ||
                detailJob.status == 6
              "
              class="w-1/4 md:w-1/5 pr-1"
            >
              <vs-button
                @click="changeStatusJob(detailJob)"
                class="w-full"
                type="filled"
                color="success"
                >Approve</vs-button
              >
            </div>
            <div class="w-1/4 md:w-1/5 pr-1">
              <vs-button
                @click="sendReminder(detailJob)"
                class="w-full flex justify-center items-center"
                type="filled"
                color="danger"
                >Reminder</vs-button
              >
            </div>
            <div
              v-if="
                (models.approvmentType == 3 && detailJob.status == 5) ||
                detailJob.status == 3 ||
                detailJob.status == 6
              "
              class="w-1/4 md:w-1/5 pr-1"
            >
              <vs-button
                v-if="detailJob.status == 3"
                @click="setRequiredReason(true)"
                class="w-full"
                type="filled"
                color="danger"
                >Reject</vs-button
              >
            </div>
          </vs-row>
        </div>
        <div v-else>
          <main class="mb-2">
            <label for="reason">Reason</label>
            <vs-textarea
              class="mb-0"
              v-model="models.revisionNote"
              v-validate="vars.reasonValidate"
              name="reject reason"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('reject reason')"
              >{{ errors.first("reject reason") }}</span
            >
          </main>
          <vs-row vs-w="12">
            <div class="w-1/3 md:w-1/4 pr-1">
              <vs-button
                @click="changeStatusJob(detailJob, 'reject')"
                class="w-full"
                type="filled"
                color="success"
                >Submit</vs-button
              >
            </div>
            <div class="w-1/3 md:w-1/4">
              <vs-button
                @click="setRequiredReason(false)"
                class="w-full"
                type="filled"
                color="danger"
                >Cancel</vs-button
              >
            </div>
          </vs-row>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="Import Resi" :active.sync="vars.popUpImport">
      <ImportExcel
        templateUrl="/templates/import-awb-campaign.xlsx"
        v-model="models.awbFile"
        @handleUpload="handleUploadAwb"
      />
    </vs-popup>
  </vs-card>
</template>

<script>
import moment from "moment";
import { getUrlOfFile, exportExcel } from "@/utils/helpers";
import api from "@/utils/api";
import ImportExcel from "../../../components/excel/ImportExcel.vue";
import ReportCard from "../../../layouts/components/ReportCard.vue";
export default {
  components: { ReportCard, ImportExcel },
  name: "ListCampaign",
  data() {
    return {
      // Brand ambassador
      config: {
        uri: this.$route.meta.link,
        api: api.campaign,
        rows: [],
        total_data: 0,
        total_page: 0,
        per_page: 10,
        page: 1,
        orderby: "id",
        sort: "desc",
        additional_params: {
          type: "brand_ambassador",
          platform: null,
          subPlatformType: null,
        },
        search: "",
        debounce: null,
        headers: [
          {
            title: "Name",
            value: "name",
            align: "text-left",
            width: "20%",
          },
          {
            title: "Tier",
            value: "tier",
            align: "text-left",
            width: "15%",
          },
          {
            title: "Status",
            value: "maritalStatus",
            align: "text-left",
            width: "20%",
          },
          {
            title: "Community",
            value: "community",
            align: "text-left",
            width: "20%",
          },
          {
            title: "Email",
            value: "email",
            align: "text-left",
            width: "15%",
          },
          {
            title: "Invoice",
            value: "",
            align: "text-left",
            width: "15%",
          },
          {
            title: "No Resi",
            value: "",
            align: "text-left",
            width: "15%",
          },
          {
            title: "Date of Birth",
            value: "bod",
            align: "text-left",
            width: "15%",
          },
          {
            title: "City",
            value: "",
            align: "text-left",
            width: "15%",
          },
          {
            title: "Province",
            value: "",
            align: "text-left",
            width: "15%",
          },
          {
            title: "Status",
            value: "status",
            align: "text-left",
            width: "20%",
          },
          {
            title: "Action",
            value: "",
            class: "text-center",
            width: "15%",
          },
        ],
      },
      models: {
        thumbnail: "",
        title: "",
        status_by_duration: "",
        category: "",
        brand: "",
        type: "",
        registration_campaign: "",
        duration_campaign: "",
        target: "",
        approvement: "",
        reward_type: "",
        campaign_type: "",
        platform_type: [],

        status: null,
        advance_search: false,
        detailJob: null,
        revisionNote: "",

        selectedUser: [],
        bulking_action: null,
        awbFile: null,
        reminderNotes: "",
        currentReminderJob: null,
      },
      masters: {
        ambassadors: [],
        reports: [],
        statuses: [
          { value: null, text: "All Status" },
          { value: "1", text: "Submission" },
          { value: "in:2,3,4,5,6", text: "On Going" },
          { value: "7", text: "Completed" },
          { value: "8", text: "Declined" },
        ],
        types: [
          {
            text: "Brand Ambassador",
            value: "brand_ambassador",
          },
          {
            text: "Report",
            value: "report",
          },
        ],
        platforms: [],
        stats: [],
        bulking_actions: [
          {
            text: "Accept",
            value: "accept-all",
          },
          {
            text: "Decline",
            value: "decline-all",
          },
        ],
      },
      vars: {
        isRejectReason: false,
        popUpBA: false,
        popUpImport: false,
        popUpReminder: false,
        reasonValidate: "",
      },
      moment,
      getUrlOfFile,
    };
  },
  async created() {
    this.getCampaign();
    this.getAmbassador();
    this.getDetailReport();
  },
  methods: {
    handleUploadAwb() {
      const form = new FormData();
      form.append("file", this.models.awbFile);
      this.$axios
        .post("/campaign/import-awb", form)
        .then(() => {
          this.$vs.notify({
            title: "Success",
            text: "Success import file",
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
          });

          this.vars.popUpImport = false;
          this.models.awbFile = null;
          this.getAmbassador();
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Failed",
            text: err.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    getCampaign() {
      if (this.$route.params.id) {
        this.$axios
          .get(`${api.campaign}/${this.$route.params.id}`)
          .then((res) => {
            const { data } = res.data;
            const headinglabel = [];
            this.models.thumbnail = data.thumbnail;
            this.models.title = data.title;
            this.models.type = data.type;
            this.models.status_by_duration = data.status_by_duration;
            this.models.category = data.category ? data.category.name : "-";
            this.models.brand = data.brand ? data.brand.name : "-";
            this.models.registration_campaign = `${moment(
              data.campaignStartDate
            ).format("DD MMMM")} - ${moment(data.campaignEndDate).format(
              "DD MMMM YYYY"
            )} `;
            this.models.duration_campaign = `${moment(
              data.durationStartDate
            ).format("DD MMMM")} - ${moment(data.durationEndDate).format(
              "DD MMMM YYYY"
            )} `;
            this.models.target = data.tierId;
            this.models.approvmentType = data.approvmentType;
            this.models.approvement = this.getApprovement(data.approvmentType);
            this.models.reward_type = data.rewardType == 1 ? "Cash" : "Loyalty";
            this.models.campaign_type = data.campaign_type
              ? data.campaign_type.name
              : "";
            this.models.platform_type = data.platformTypeId
              .sort()
              .map((platform) => {
                let type = "";
                let labelTable = "";
                let labelValue = "";
                switch (platform) {
                  case 1:
                    type = "Instagram";
                    labelTable = "Instagram Followers";
                    labelValue = "followerIG";
                    break;
                  case 2:
                    type = "Facebook";
                    labelTable = "Facebook Friends";
                    labelValue = "followerFB";
                    break;
                  case 3:
                    type = "Tiktok";
                    labelTable = "Tiktok Followers";
                    labelValue = "followerTT";
                    break;
                  case 4:
                    type = "Youtube";
                    labelTable = "Subscribers Youtube";
                    labelValue = "followerYT";
                    break;
                  case 5:
                    type = "Twitter";
                    labelTable = "Twitter Followers";
                    labelValue = "followerTwitter";
                    break;
                  case 6:
                    type = "Lemon8";
                    labelTable = "Lemon8 Followers";
                    labelValue = "followerLemon8";
                    break;
                  case 7:
                    type = "Shopee";
                    labelTable = "Shopee Followers";
                    labelValue = "followerShopee";
                    break;
                  case 8:
                    type = "GDrive";
                    labelTable = "";
                    labelValue = "";
                    break;
                  case 9:
                    type = "Threads";
                    labelTable = "Threads Followers";
                    labelValue = "followerThreads";
                    break;
                  default:
                    break;
                }

                headinglabel.push({
                  title: labelTable,
                  value: labelValue,
                  class: "text-left",
                  width: "15%",
                });

                const tempPlatform = {
                  text: type,
                  value: type.toLowerCase(),
                  subPlatform: [],
                };

                data.subPlatformTypeId = data.subPlatformTypeId || [];
                // parse subPlatformRequiredLinks which may be object or JSON string
                let spRequired = {};
                try {
                  if (data.subPlatformRequiredLinks) {
                    if (typeof data.subPlatformRequiredLinks === "string") {
                      spRequired = JSON.parse(data.subPlatformRequiredLinks);
                    } else if (
                      typeof data.subPlatformRequiredLinks === "object"
                    ) {
                      spRequired = data.subPlatformRequiredLinks || {};
                    }
                  }
                } catch (e) {
                  spRequired = {};
                }

                const subPlatformText = this.$store.state.platforms
                  .find(
                    (platform) =>
                      platform.name.toLowerCase() === type.toLowerCase()
                  )
                  .subPlatform.filter((sub) =>
                    data.subPlatformTypeId.includes(sub.id)
                  )
                  .map((sub) => {
                    tempPlatform.subPlatform.push(sub);
                    // try to get count from spRequired (keys may be string or number)
                    var count =
                      typeof spRequired[sub.id] !== "undefined"
                        ? spRequired[sub.id]
                        : spRequired[String(sub.id)];
                    return count ? `${sub.name} (${count})` : sub.name;
                  });

                this.masters.platforms.push(tempPlatform);

                return {
                  type,
                  subPlatformText,
                };
              });

            headinglabel.reverse().forEach((label) => {
              this.config.headers.splice(5, 0, label);
            });
          });
        /*.catch(() =>
            this.$router.push({
              name: "page404",
            })
          );*/
      }
    },
    gotoPage(page) {
      sessionStorage.setItem(
        "campaign_ba_pagination",
        JSON.stringify({
          route: "campaign",
          page: this.config.page,
        })
      );
      this.config.page = page;
      this.getAmbassador();
    },
    handleSort(key, sortBy) {
      if (key) {
        sessionStorage.setItem("campaign_ba_pagination", 1);
        this.config.orderby = key;
        this.config.sort = sortBy || "desc";
        this.getAmbassador();
      }
    },
    followerFormatter(value) {
      if (!value) {
        return "-";
      } else {
        return Math.abs(Number(value)) >= 1.0e9
          ? `${(Math.abs(Number(value)) / 1.0e9).toFixed(2)}B`
          : // Six Zeroes for Millions
          Math.abs(Number(value)) >= 1.0e6
          ? `${(Math.abs(Number(value)) / 1.0e6).toFixed(2)}M`
          : // Three Zeroes for Thousands
          Math.abs(Number(value)) >= 1.0e3
          ? `${(Math.abs(Number(value)) / 1.0e3).toFixed(2)}K`
          : Math.abs(Number(value));
      }
    },
    tierName(row) {
      if (!row) return "";

      return row.tier && row.tier.name
        ? row.tier.name
        : row.tierName || row.tier_name || "";
    },

    // Brand ambassador
    getAmbassador() {
      const pagination = JSON.parse(
        sessionStorage.getItem("campaign_ba_pagination")
      );
      if (pagination) {
        this.config.page = pagination.page;
      }
      const status = this.models.status;
      if (this.$route.params.id) {
        const sortBy = `${this.config.orderby}.${this.config.sort}`;
        const params = {
          sortBy,
          page: this.config.page,
          limit: this.config.per_page,
          campaignId: this.$route.params.id,
          status,
        };
        this.$axios
          .get(`${api.appliesCampaign}`, {
            params,
          })
          .then((res) => {
            const { count, rows, totalPages } = res.data.data;
            this.config.rows = rows;
            this.masters.ambassadors = rows;
            this.config.total_data = count;
            this.config.total_page = totalPages;
          });
      }
    },

    getDetailReport() {
      this.$axios
        .get(`/job-content/detail/${this.$route.params.id}`)
        .then((res) => {
          const { data } = res.data;

          for (const report in data) {
            this.masters.stats.push({
              value: data[report],
              text: report.replaceAll("_", " "),
            });
          }
        });
    },

    changeStatus(status, id) {
      if (status && id) {
        this.$axios
          .post(api.changeStatusCampaign, { id, status })
          .then((res) => {
            this.$refs.response.setResponse(res.data, "success");
            this.getAmbassador();
          })
          .catch((error) =>
            this.$refs.response.setResponse(error.response.data, "danger")
          );
      }
    },

    rejectApplies(id, status) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure want to declined this ambassadors applies?",
        acceptText: "Yes",
        cancelText: "No",
        accept: () => {
          this.changeStatusSub(id, status);
        },
      });
    },

    changeStatusSub(id, status) {
      this.$axios
        .post(api.changeStatusSub, { id, status })
        .then((res) => {
          this.$refs.response.setResponse(res.data, "success");
          this.getAmbassador();
        })
        .catch((error) => {
          this.$refs.response.setResponse(error.response.data, "danger");
        });
    },

    changeStatusJob(job, reject) {
      const request =
        job.status === 3
          ? api.changeStatusJobDraft
          : api.changeStatusJobPublish;
      let body = {
        jobId: job.id,
        status: Boolean(!reject),
      };

      if (reject && job.status === 3) {
        body.revisionNote = this.models.revisionNote;
      }

      if (job.status == 3) {
        body.id = job.job_drafts.id;
      }

      this.$validator.validate().then(async (valid) => {
        if (valid) {
          this.$axios
            .post(request, body)
            .then((res) => {
              this.$refs.response.setResponse(res.data, "success");
              this.vars.isRejectReason = false;
              this.vars.popUpBA = false;
              this.vars.reasonValidate = "";
              this.getAmbassador();
            })
            .catch((error) => {
              this.vars.popUpBA = false;
              this.$vs.dialog({
                color: "warning",
                title: `Failed ${reject ? "reject" : "approve"} content!`,
                text: error.response.data.message,
                acceptText: "Close",
              });
              this.$refs.response.setResponse(error.response.data, "danger");
            });
        }
      });
    },

    setRequiredReason(action) {
      this.vars.reasonValidate = action ? "required" : "";
      this.vars.isRejectReason = action;
    },

    sendReminder(job) {
      if (job && job.userId) {
        this.models.currentReminderJob = job;
        console.log(job);
        this.models.reminderNotes = "";
        this.vars.popUpReminder = true;
      } else {
        console.log("No userId found in job:", job);
      }
    },

    sendReminderWithNotes() {
      if (
        this.models.currentReminderJob &&
        this.models.currentReminderJob.userId
      ) {
        const payload = {
          userId: this.models.currentReminderJob.userId,
          notes: this.models.reminderNotes,
          campaignId: this.$route.params.id,
          jobId: this.models.currentReminderJob.id,
        };

        this.$axios
          .post(`${api.brandAmbasador}/send-reminder-with-notes`, payload)
          .then((res) => {
            this.$vs.notify({
              title: "Success",
              text: "Reminder sent successfully",
              iconPack: "feather",
              icon: "icon-check-circle",
              color: "success",
            });

            // Close popup and reset data
            this.closeReminderPopup();
          })
          .catch((error) => {
            this.$vs.notify({
              title: "Failed",
              text:
                error.response &&
                error.response.data &&
                error.response.data.message
                  ? error.response.data.message
                  : "Failed to send reminder",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          });
      }
    },

    closeReminderPopup() {
      this.vars.popUpReminder = false;
      this.models.reminderNotes = "";
      this.models.currentReminderJob = null;
    },

    handleSelected(val) {
      const routeData = this.$router.resolve({
        name: "detailbrand",
        params: { id: val.userId, fromCampaign: this.$route.params.id },
      });
      window.open(routeData.href, "_blank");
    },

    cancelJob(jobId) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure want to cancel this job?",
        acceptText: "Yes",
        cancelText: "No",
        accept: () => {
          this.$axios
            .get(`${api.campaignJob}/cancel-job/${jobId}`)
            .then((res) => {
              this.$refs.response.setResponse(res.data, "success");
              this.getAmbassador();
            })
            .catch((error) => {
              this.$refs.response.setResponse(error.response.data, "danger");
            });
        },
      });
    },
    getDetailJob(jobId) {
      this.$axios
        .get(`${api.campaignJob}/${jobId}`)
        .then((res) => {
          const { data } = res.data;
          // job_content: [{..., links: [...]}, ...]
          data.job_content = (data.job_content || [])
            .sort((a, b) =>
              a.platformText > b.platformText
                ? 1
                : b.platformText > a.platformText
                ? -1
                : 0
            )
            .map((job) => {
              var foundIcon = (this.$store.state.socMedsIcons || []).find(
                function (icon) {
                  return job.platformText == icon.name;
                }
              );
              return {
                ...job,
                icon: foundIcon ? foundIcon.icon : "",
                links: Array.isArray(job.links) ? job.links : [],
              };
            });
          this.models.detailJob = data;
          this.vars.popUpBA = true;
        })
        .catch((error) => {
          this.$refs.response.setResponse(error.response.data, "danger");
        });
    },

    exportExcel() {
      let fullUrl = `${api.campaign}/excel-campaign?campaignId=${this.$route.params.id}`;
      if (this.models.status) {
        fullUrl += `&status=${this.models.status}`;
      }

      // Clean and truncate campaign title for filename
      let cleanTitle = this.models.title
        .replace(/[<>:"/\\|?*\[\]]/g, "") // Remove invalid filename characters
        .replace(/\s+/g, " ") // Replace multiple spaces with single space
        // replace titik (.) with "-"
        .replace(/\./g, "-")
        .trim();

      const limitLengthName = 100;
      // Limit title length to prevent filename issues (max 30 chars for title part)
      if (cleanTitle.length > limitLengthName) {
        cleanTitle = cleanTitle.substring(0, limitLengthName).trim();
      }

      const dateStr = moment().format("DD-MM-YYYY");
      const filename = `List BA Campaign ${cleanTitle} (${dateStr})`;

      exportExcel(fullUrl, filename);
    },
    exportER() {
      // Clean and truncate campaign title for filename
      let cleanTitle = this.models.title
        .replace(/[<>:"/\\|?*\[\]]/g, "") // Remove invalid filename characters
        .replace(/\s+/g, " ") // Replace multiple spaces with single space
        .replace(/\./g, "-")
        .trim();

      // Limit title length to prevent filename issues (max 50 chars for title part)
      if (cleanTitle.length > 50) {
        cleanTitle = cleanTitle.substring(0, 50).trim();
      }

      const dateStr = moment().format("DD-MM-YYYY");
      const filename = `List ER ${this.config.additional_params.platform} Campaign ${cleanTitle} ${dateStr}`;

      exportExcel(
        `/job-content/excel/${this.$route.params.id}/${this.config.additional_params.platform}`,
        filename
      );
    },

    syncER() {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "Sync ER",
        text: "Sync engagement rate dari Instagram dan TikTok?",
        acceptText: "Yes",
        cancelText: "No",
        accept: () => {
          this.$axios
            .post(`/campaign/${this.$route.params.id}/sync-socialkit`)
            .then((res) => {
              console.log(res);
              // Check if response has success flag
              console.log("res.data:", res.data);
              if (res.data && res.data.success === false) {
                console.error(`Sync ER failed2:`, res.data);
                const errorMessage = res.data.message || "Sync failed";
                this.$showToast("Error", errorMessage, "danger");
                return;
              }

              this.$showToast("Success", res.data.message, "success");
              // Refresh reports after sync
              this.getReports();
            })
            .catch((error) => {
              console.error(`Sync ER error:`, error);
              const errorMessage =
                error.response && error.response.data.data
                  ? error.response.data.message
                  : "Sync failed";
              this.$showToast("Error", errorMessage, "danger");
            });
        },
      });
    },

    getReports() {
      if (this.platform) {
        this.$axios
          .get(`job-content/${this.$route.params.id}/${this.platform}`, {
            params: Object.assign({
              subPlatformType: this.subplatform,
            }),
          })
          .then((res) => {
            this.masters.reports = res.data.data.rows;
          });
      }
    },

    bulkChangeStatus() {
      if (this.models.selectedUser.length) {
        const actions = this.models.bulking_action.replace("-", " ");
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: "Confirm",
          text: `Are you sure want to ${actions} user?`,
          acceptText: "Yes",
          cancelText: "No",
          accept: () => {
            const bulkAction = this.models.bulking_action.includes("accept")
              ? "bulk-accept"
              : "bulk-decline";
            let selectedUser = this.models.selectedUser;

            if (this.models.bulking_action.includes("accept")) {
              selectedUser = selectedUser.filter((user) => user.status === 1);
            } else {
              selectedUser = selectedUser.filter(
                (user) => user.status !== 7 && user.status !== 8
              );
            }

            if (!selectedUser.length) {
              this.$refs.response.setResponse(
                {
                  message:
                    "The selected user does not meet the bulk action requirements",
                },
                "danger"
              );
              return;
            }
            this.$axios
              .post(`${api.campaign}/${bulkAction}`, {
                campaignId: this.$route.params.id,
                ids: selectedUser.map((user) => user.id),
              })
              .then((res) => {
                this.$refs.response.setResponse(res.data, "success");
                this.getAmbassador();
              })
              .catch((error) =>
                this.$refs.response.setResponse(error.response.data, "danger")
              );
          },
        });
      } else {
        this.$refs.response.setResponse(
          { message: "You must selected minimal 1 user to bulk action" },
          "danger"
        );
      }
    },
    revertDecline(user) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: `Are you sure want to set ${user.name} status to Submission?`,
        acceptText: "Yes",
        cancelText: "No",
        accept: () => {
          this.$axios
            .post(`${api.campaign}/change-status-decline`, {
              campaignId: this.$route.params.id,
              campaignApplyId: user.id,
            })
            .then((res) => {
              this.$refs.response.setResponse(res.data, "success");
              user.status = 1;
              user.status_apply = "Submission";
            })
            .catch((error) =>
              this.$refs.response.setResponse(error.response.data, "danger")
            );
        },
      });
    },
    getApprovement(id) {
      let approvmentType = "";
      switch (id) {
        case 1:
          approvmentType = "All With Approvement";
          break;
        case 2:
          approvmentType = "All Without Approvement";
          break;
        case 3:
          approvmentType = "Without Report";
          break;
      }
      return approvmentType;
    },
    maritalStatus(val) {
      const list = {
        1: "Single",
        2: "Menikah",
        3: "Punya Anak",
      };

      if (val === null) return "-";

      return list[val];
    },
  },
  computed: {
    type() {
      return this.config.additional_params.type;
    },
    platform() {
      return this.config.additional_params.platform;
    },
    subplatform() {
      return this.config.additional_params.subPlatformType;
    },
    subPlatformList() {
      return this.masters.platforms.find(
        (platform) =>
          platform.text.toLowerCase() === this.config.additional_params.platform
      ).subPlatform;
    },
    detailJob() {
      return this.models.detailJob;
    },
    statusApplied() {
      return this.models.status;
    },
    platformTypeText() {
      return this.models.platform_type.map((platform) => platform.type);
    },
  },
  watch: {
    type() {
      if (this.type === "report") {
        this.config.additional_params.platform =
          this.masters.platforms[0].value;
      }
    },
    platform() {
      this.config.additional_params.subPlatformType = this.subPlatformList
        .length
        ? this.subPlatformList[0].id
        : null;
      this.getReports();
    },
    statusApplied() {
      this.config.page = 1;
      this.getAmbassador();
    },
    "config.per_page"() {
      this.config.page = 1;
      this.getAmbassador();
    },
  },
};
</script>
